// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".gallery[data-v-b5bac020] .slick-slide>div{outline:0}.gallery[data-v-b5bac020] .media-wrap{outline:0;display:block!important}.gallery[data-v-b5bac020] .media-item{pointer-events:none}", ""]);
// Exports
module.exports = exports;
